import { Injectable } from '@angular/core';

import { IError, ErrorCategoryType } from 'common-lib';
import { ERROR_MESSAGES } from './error-messages.data';
import * as _ from 'lodash';

/* ERROR SERVICE */
// To create a new error, add it to error-messages.data
@Injectable({
    providedIn: 'root'
})
export class ErrorService {
    currentError: IError;

    constructor() {}

    /** To make translations compatible with old error system, we check if a translation exists and use it if it does */
    public setError(errorKey: keyof typeof ERROR_MESSAGES, values?: { content?: string; title?: string; meta?: any }) {
        const errorMessage = _.cloneDeep(this.errorLookup(ERROR_MESSAGES, errorKey));

        if (values && values.content && typeof errorMessage.content === 'string') {
            errorMessage.content = errorMessage.content.replace(/(\$\w+)/g, values.content);
        }

        if (values && values.title) {
            errorMessage.title = errorMessage.title.replace(/(\$\w+)/g, values.title);
        }

        if (values?.meta) {
            errorMessage.meta = values.meta;
        }

        this.currentError = this.setDefaults(errorMessage);
    }

    // Convenience method specifically for server errors
    public setServerError(error: string, category?: ErrorCategoryType) {
        const errorMessage = _.cloneDeep(this.errorLookup(ERROR_MESSAGES, 'server-error'));
        const errorContentRegex = /(\$\w+)/g;
        const errorCodeRegex = /(\(\d{3}\))/g;
        if (typeof errorMessage.content === 'string') {
            errorMessage.content = errorMessage.content.replace(errorContentRegex, error);
            errorMessage.content = errorMessage.content.replace(errorCodeRegex, '');
            if (errorMessage.content.indexOf('Invalid payload') > -1) {
                errorMessage.content = errorMessage.content.substring(errorMessage.content.lastIndexOf(': ') + 2);
            }
        }

        if (category) errorMessage.category = category;
        this.currentError = errorMessage;
    }

    public setCustomError(error: IError) {
        this.currentError = this.setDefaults(error);
    }

    public clearError(category?: string) {
        // if no category specified, clear all errors
        if (!category) {
            this.currentError = null;
            // if category is provided, only clear error if it matches the current error
        } else if (category === this.currentError.category) {
            this.currentError = null;
        }
    }

    private errorLookup<T, K extends keyof T>(obj: T, key: K) {
        return obj[key];
    }

    private setDefaults(error: IError) {
        const genericError = ERROR_MESSAGES['generic'];

        error.category = error.category || genericError.category;
        error.icon = error.icon || genericError.icon;
        error.title = error.title || genericError.title;
        error.content = error.content || genericError.content;
        error.cta = error.cta || genericError.cta;

        return error;
    }
}
